import { CommonAPIService } from 'src/servicehandlers/CommonHandler';

export class PaymentMethodsAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  getAllPaymentMethods(router){
    const url = `/api/paymentMethods`
    return this.CommonAPIService.getCall(url, null, router)
  }

  getAllPaymentMethodsForSchool(schoolId, router){
    const url = `/api/paymentMethods/school/${schoolId}`
    return this.CommonAPIService.getCall(url, null, router)
  }

  getPaymentMethodsById(id, router) {
    const url = `/api/paymentMethods/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  getAccountById(id, router){
    const url = `/api/paymentMethods/account/${id}`
    return this.CommonAPIService.getCall(url, null, router)
  }

  getCreditCardById(id, router){
    const url = `/api/paymentMethods/creditCard/${id}`
    return this.CommonAPIService.getCall(url, null, router)
  }

  createPaymentMethod(params, router) {
    const url = `/api/paymentMethods`;
    return this.CommonAPIService.postCall(url, params, router);
  }

  updatePaymentMethod(id, params, router) {
    const url = `/api/paymentMethods/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  deletePaymentMethod(id, router) {
    const url = `/api/paymentMethods/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

}
export default PaymentMethodsAPIService;
